// extracted by mini-css-extract-plugin
export default {"wrapper":"components-IconButton-IconButton-module__wrapper--mIA9e","referenceWrapper":"components-IconButton-IconButton-module__referenceWrapper--nsLAx"};